export default __webpack_public_path__ + "static/media/logo.739dea7d.svg";